import { Helmet } from "react-helmet";
// import DashHeader from "../component/dashheader";
// import homeTradeofCreditType from '../asset/im
import SerHeader from "../component/serviceheader";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import checkboxbase from "../asset/images/tradecredit/_Checkbox base.svg";
import shipping from "../asset/images/usertouser.svg";
import inventory from "../asset/images/cardpayment.png";
import ArrowBack from "../component/arrowback";
import TopUpTransfer from "../component/topUpTransfer";
import SuccessHolder from "../component/SuccessHolder";
import FailHandler from "../component/failhandler";
import bank from "../asset/images/newbanktransfer.svg";
//import cashflow from "../asset/images/tradecredit/cashflow.svg";

const TopupType = (props) => {
  const navigate = useNavigate();
  const [selectedindex, setselectedindex] = useState(-1);
  const [showwallet, setshowallet] = useState(false);
  const [showsuccess, setshowsuccess] = useState(false);
  const [message, setmessage] = useState("");
  const [fail, setfail] = useState(false);
  //const { id } = useParams();
  const { state } = useLocation();
  const type = [
    {
      subject: "Payment Link",
      title: "Use a payment link to request funds.",
      image: shipping,
    },

    {
      subject: "Card payment",
      title: "Use your credit or debit card to top up.",
      image: inventory,
    },
    {
      subject: "Bank Transfer",
      title: "Transfer to bank account.",
      image: bank,
    },
  ];
  const goanotherpage = () => {
    if (selectedindex === 0) {
      navigate(`/topup/payment_link`, {
        state: {
          ...state,
          // type: "tradevuuser",
        },
      });
    } else if (selectedindex === 2) {
      alert("Bank Transfer");
    } else {
      navigate(`/topup/card`, {
        state: {
          ...state,
          // type: "bankuser",
        },
      });
    }
  };
  useEffect(() => {
    if (fail == true) {
      //setisdisable(false);
      setTimeout(() => {
        setfail(false);
      }, 3000);
    }
    if (showsuccess == true) {
      //setshowsuccess(false);
      setTimeout(() => {
        setshowsuccess(false);
      }, 3000);
    }
  }, [fail, showsuccess]);
  return (
    <div className="h-100 w-100 ">
      <div
        className=""
        style={{
          maxWidth: "2000px",
          width: "100%",
          margin: "0px auto",
        }}
      >
        <Helmet>
          <title>Top Up</title>
        </Helmet>

        <SerHeader header={"Top Up"} width={35} />
        <TopUpTransfer
          show={showwallet}
          setshow={setshowallet}
          setshowsuccess={setshowsuccess}
          setfail={setfail}
          setmessage={setmessage}
        />
      </div>
      <div style={{ height: "100%" }}>
        <div
          className="conatiner "
          style={{
            maxWidth: "2000px",
            margin: "0px auto",
            paddingLeft: "30px",
            paddingRight: "30px",
            paddingTop: "10px",
            paddingBottom: "10px",
            width: "100%",
          }}
        >
          <div
            style={{
              height: "100%",
              width: "100%",
              display: "flex",

              justifyContent: "center",
            }}
          >
            <div
              className="form-general-layout"
              style={{
                position: "relative",
                maxWidth: "538px",
                width: "100%",
              }}
            >
              <SuccessHolder success={showsuccess} message={message} />
              <FailHandler success={fail} message={message} />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
              >
                <ArrowBack />
                <div className="">
                  <div
                    style={{
                      color: "#101828",
                      fontSize: "24px",
                      lineHeight: "32.4px",
                      fontWeight: "600",
                    }}
                  >
                    Fund with
                  </div>
                </div>
              </div>
              <div className="">
                <div className="card border-0">
                  <div className="card-body p-1">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                      }}
                    >
                      {" "}
                      {type.map((item, index) => (
                        <div
                          key={index}
                          style={{
                            padding: "8px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            position: "relative",
                            background:
                              selectedindex === index ? "#EDFCFE" : "",
                            borderRadius: "8px",
                          }}
                          onClick={() => {
                            if (index === 2) {
                              setshowallet(true);
                            }
                            setselectedindex(index);
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              gap: "16px",
                            }}
                          >
                            <img
                              src={item.image}
                              alt=""
                              width={48}
                              height={48}
                            />
                            <div
                              style={{
                                overflow: "hidden",
                                display: "flex",
                                flexDirection: "column",
                                gap: "4px",
                              }}
                            >
                              <div
                                style={{
                                  color: "#101828",
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                  letterSpacing: "2%",
                                  fontWeight: "600",
                                }}
                              >
                                {" "}
                                {item.subject}{" "}
                              </div>
                              <p
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "400",
                                  lineHeight: "19.6px",
                                  color: "#667085",
                                }}
                              >
                                {" "}
                                {item.title}{" "}
                              </p>
                            </div>
                          </div>
                          {selectedindex === index && (
                            <div>
                              <img src={checkboxbase} alt="" />
                            </div>
                          )}{" "}
                        </div>
                      ))}{" "}
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <button
                  onClick={goanotherpage}
                  style={{
                    maxWidth: "278px",
                    width: "100%",
                    background: "#6F00FF",
                    color: "#fff",
                    padding: "16px 24px 16px 24px",
                    letterSpacing: "2%",
                    fontSize: "16px",
                    fontWeight: "500",
                    lineHeight: "24px",
                    borderRadius: "8px",
                    outline: "none",
                    border: "none",
                    minHeight: "46px",
                  }}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopupType;
